import React, { Component } from 'react';

import { Menu } from '@vimeo/iris/layout';
import { Header } from '@vimeo/iris/typography';

import styles from './ContextualMenuNavigation.module.scss';

export default class ContextualMenuNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      links: [],
    };
  }

  componentDidMount() {
    this.setState({
      links: this.getLinks(),
    });
  }

  getNavigation() {
    let menu = [];
    let links = this.state.links;

    Object.keys(links).forEach(function (menuItem) {
      menuItem = links[menuItem];

      menu.push(
        <Menu.Item
          className={styles.parent_link}
          key={`context-nav-${menuItem.name}`}
          href={menuItem.link}
        >
          {menuItem.name}
        </Menu.Item>,
      );

      if (menuItem.sublinks !== undefined) {
        menuItem.sublinks.map(function (subMenuItem) {
          menu.push(
            <Menu.Item
              className={styles.child_link}
              key={`context-nav-${menuItem.name}-${subMenuItem.name}`}
              href={subMenuItem.link}
            >
              {subMenuItem.name}
            </Menu.Item>,
          );
        });
      }
    });

    return menu;
  }

  isActive(link) {
    return window.location.hash.endsWith(link.substr(link.indexOf('#')));
  }

  getLinks() {
    let parentSlug = null;
    let links = {};
    let headers = document.getElementById('main_content').querySelectorAll('h2');

    headers.forEach(function (header) {
      let attrs = header.attributes;

      // If this header either has a `no-sidebar` data attribute, or is absent of an ID, then don't
      // put it in the contextual navigation.
      if (typeof attrs['data-no-sidebar'] !== 'undefined') {
        return;
      } else if (typeof attrs['id'] === 'undefined') {
        return;
      }

      let tag = header.tagName.toLowerCase();
      let slug = attrs.id.value;

      if (tag === 'h3') {
        links[parentSlug].sublinks.push({
          name: header.innerText,
          link: '#' + slug,
        });
      } else if (tag === 'h2') {
        parentSlug = slug;

        links[slug] = {
          name: header.innerText,
          link: '#' + slug,
          sublinks: [],
        };
      }
    });

    return links;
  }

  render() {
    if (Object.keys(this.state.links).length === 0) {
      return null;
    }
    return (
      <div id="right_nav" className={styles.sticky_side_nav}>
        <Header size="5">On this page</Header>
        <div>{this.getNavigation()}</div>
      </div>
    );
  }
}
